<template>
  <el-dialog title="维护合同档案号" :visible.sync="visible" width="420px" append-to-body>
    <el-form ref="archiveForm" :model="form" :rules="rules" label-width="85px">
      <el-form-item label="档案号" prop="archiveNo">
        <el-input v-model.trim="form.archiveNo" maxlength="64" show-word-limit placeholder="请输入档案号" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateArchiveNo } from '@/api/crm/contract'

export default {
  name: 'ContractArchive',
  data () {
    return {
      visible: false,
      submitting: false,
      form: { contractId: null, archiveNo: '' },
      rules: {
        archiveNo: [
          { required: true, message: '请输入档案号', trigger: 'blur' },
          { max: 64, message: '档案号不能超过64个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    options (contractId, archiveNo) {
      this.form = { contractId, archiveNo: archiveNo || '' }
      this.visible = true
      this.$nextTick(() => this.$refs.archiveForm && this.$refs.archiveForm.clearValidate())
    },
    submit () {
      this.$refs.archiveForm.validate(valid => {
        if (!valid) return
        this.submitting = true
        updateArchiveNo(this.form).then(() => {
          this.msgSuccess('档案号保存成功')
          this.visible = false
          this.$emit('success')
        }).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>
